import React from "react";
import { connect } from "react-redux";
import { Container, Grid, Typography, AppBar, Toolbar, IconButton, Popper, Box } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import clsx from "clsx";
import { withTranslation } from 'react-i18next';
import { authHeader } from "../../_helpers";
import { Add } from "@mui/icons-material";
import AddRepairRequest from "../Aftercare/AddRepairRequest";
import { flushSync } from "react-dom";
import BuyerRepairRequestsGrid from "./BuyerRepairRequestsGrid";


const { webApiUrl } = window.appConfig;

const styles = theme => ({
    appBar: {
    },
    grow: {
        flexGrow: 1
    },
    bold: {
        fontWeight: "bold"
    },
    mainContainer: {
        height: '100%',
        paddingTop: theme.spacing(5),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0)
        }
    },
    container: {
        //backgroundColor: theme.palette.background.paper,
        height: '100%',
        position: 'relative',
        overflow: 'auto'
    },
    gridWrapper: {
        maxHeight: 'calc(100% - 48px)',
        overflow: 'auto',
        width: '100%',
        height:'100%',
    },
    welcomePanel: {
        color: theme.palette.common.white,
        height: '40vh',
        position: 'relative',
        padding: theme.spacing(5, 0),
        '& h1': {
            textShadow: '0 0 10px rgb(0,0,0)'
        }
    },
    thumbnail: {
        width: 50,
        height: 50,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundColor: 'rgba(0,0,0,0.1)',
        margin: theme.spacing(-1.5, 0)
    }
});


class Page extends React.Component {
    state = {
        requests: [],
        searchTerm: '',
        popperImageId: null,
        popperAnchorId: null,
        selectedStatus: 'all'
    };

    componentDidMount() {
        this.UpdateRepairRequests();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.selected || !this.props.selected || prevProps.selected.buildingId.toUpperCase() !== this.props.selected.buildingId.toUpperCase()) {
            this.UpdateRepairRequests();
        }
    }

    UpdateRepairRequests() {
        const { selected } = this.props;
        if (selected) {
            const url = webApiUrl + 'api/RepairRequest/GetRepairRequests/' + encodeURI(selected.buildingId);
            const requestOptions = {
                method: 'GET',
                headers: authHeader()
            };
           flushSync(()=>{
           this.setState({
                requests: [],
                searchTerm: '',
                selectedStatus: 'all'
            });
           })
        
            fetch(url, requestOptions)
                .then(Response => Response.json())
                .then(findResponse => {
                   flushSync(()=>{ this.setState({ requests: findResponse });})
                });
        }
    }

    render() {
        const {classes, selected } = this.props;
        const { requests, openAddRepairRequest } = this.state;
        return (<>
            <Container className={classes.mainContainer}>
                <Grid container className={classes.container} direction="column">
                    <AppBar position="static" color='inherit' className={classes.appBar}>
                        <Toolbar variant="dense">
                            <Typography className={clsx(classes.grow, classes.bold)}>{selected && selected.address}</Typography>
                            {
                                selected.isAfterCareStarted === true &&
                                <IconButton
                                    color="inherit"
                                edge="end"
                                aria-label="new Action" component="span"
                                    onClick={() => flushSync(()=>{this.setState({ openAddRepairRequest: true  });})}
                                    size="large">
                                    <Add />
                                </IconButton>
                            }
                        </Toolbar>
                    </AppBar>
                    <Grid className={classes.gridWrapper} size={{xs:12}}>
                        <BuyerRepairRequestsGrid
                         data={requests}
                        />
                    </Grid>
                </Grid>
                <Popper
                    id="mouse-over-popper"
                    open={this.state.popperImageId !== null}
                    anchorEl={this.state.popperAnchorId}
                    placement="right" disablePortal={false}
                    modifiers={{
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'scrollParent',
                        },
                        arrow: {
                            enabled: false,
                            element: this.state.popperAnchorId,
                        },
                    }}
                >
                    <Box
                        component="img"
                        src={'/api/home/getattachment/' + this.state.popperImageId}
                        alt=""
                        style={{
                                maxWidth: '80%',
                                maxHeight: '80vh',
                                backgroundColor: '#fff'
                            }}
                        sx={{
                            boxShadow: 1,
                            borderRadius: 1
                        }}>
                    </Box>
                </Popper>
            </Container>
            {
                openAddRepairRequest &&
                <AddRepairRequest
                    repairRequestCreateCallBack={() => {
                        this.UpdateRepairRequests()
                        flushSync(()=>{this.setState({ openAddRepairRequest: false });})
                    }}
                    isOpenObjectModal={false}
                    setIsOpenObjectModal={(value) => { }}
                    building={selected}
                    handleCloseNewRepairRequestModal={() => { flushSync(()=>{this.setState({ openAddRepairRequest: false });}) }}
                />
            }
        </>);
    }
}

function mapStateToProps(state) {
    const { authentication, buildings, dashboardCount } = state;
    const { user } = authentication;
    const { selected, all } = buildings;
    const { quotationsCount } = dashboardCount;
    return {
        user,
        selected,
        buildings: all,
        quotationsCount
    };
}

const connectedPage = connect(mapStateToProps)(withTranslation()(withStyles(styles)(Page)));
export { connectedPage as RepairRequestsHomePage };
